"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaSignatureToJSON = exports.RosettaSignatureFromJSONTyped = exports.RosettaSignatureFromJSON = exports.RosettaSignatureSignatureTypeEnum = void 0;
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var RosettaSignatureSignatureTypeEnum;
(function (RosettaSignatureSignatureTypeEnum) {
    RosettaSignatureSignatureTypeEnum["ecdsa"] = "ecdsa";
    RosettaSignatureSignatureTypeEnum["ecdsa_recovery"] = "ecdsa_recovery";
    RosettaSignatureSignatureTypeEnum["ed25519"] = "ed25519";
    RosettaSignatureSignatureTypeEnum["schnorr_1"] = "schnorr_1";
    RosettaSignatureSignatureTypeEnum["schnorr_poseidon"] = "schnorr_poseidon";
})(RosettaSignatureSignatureTypeEnum = exports.RosettaSignatureSignatureTypeEnum || (exports.RosettaSignatureSignatureTypeEnum = {}));
function RosettaSignatureFromJSON(json) {
    return RosettaSignatureFromJSONTyped(json, false);
}
exports.RosettaSignatureFromJSON = RosettaSignatureFromJSON;
function RosettaSignatureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signing_payload': _1.SigningPayloadFromJSON(json['signing_payload']),
        'public_key': _1.RosettaPublicKeyFromJSON(json['public_key']),
        'signature_type': json['signature_type'],
        'hex_bytes': json['hex_bytes'],
    };
}
exports.RosettaSignatureFromJSONTyped = RosettaSignatureFromJSONTyped;
function RosettaSignatureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signing_payload': _1.SigningPayloadToJSON(value.signing_payload),
        'public_key': _1.RosettaPublicKeyToJSON(value.public_key),
        'signature_type': value.signature_type,
        'hex_bytes': value.hex_bytes,
    };
}
exports.RosettaSignatureToJSON = RosettaSignatureToJSON;
//# sourceMappingURL=RosettaSignature.js.map